import React, { useState } from "react"

// s4n
import { injectIntl, Link } from "gatsby-plugin-intl"
import kebabCase from "lodash.kebabcase"
import classNames from 'classnames';
import { Collapse } from 'react-bootstrap'


const ComponentStateless = (props) => {
    const { intl, pageContext, linkTranslation } = props;
    const t = intl.formatMessage;

    let ButtonClass = classNames({
        // "btn mr-1": true,
        // 'btn-primary': typeof pageContext.tag === `undefined`,
        // 'btn-outline-primary': typeof pageContext.tag !== `undefined`,
        'list-group-item': true,
        'active': pageContext.category === ``,
    });

    const [open, setOpen] = useState(true);

    return (
        <React.Fragment>
            <div className="collapse-wrapper">
                <a
                    // href="#"
                    onClick={() => setOpen(!open)}
                    aria-controls="collapse-category-container"
                    aria-expanded={open}
                    className={`btn btn-primary text-left w-100 collapse-indicator ${open ? `` : `collapsed`}`}
                >
                    { t({ id: "soft4net_lists_division_categories" }) }
                </a>
                <Collapse in={open}>
                    <div 
                        id="collapse-category-container" 
                        // className="card card-body p-0" // ~ ___list-group-flush
                    >
                        <ul className="list-group ___list-group-flush">
                            <li className={ButtonClass}>
                                <Link to={`/${linkTranslation}`} role="button">
                                    { t({ id: "soft4net_lists_division_tags_all" }) }
                                    <span className="badge badge-primary">{pageContext.countCategories[`undefined`]}</span>
                                </Link>
                            </li>
                            {pageContext.allCategories.map((category, index) => {
                                ButtonClass = classNames({
                                    // "btn mr-1": true,
                                    // 'btn-primary': category === pageContext.category,
                                    // 'btn-outline-primary': category !== pageContext.category,
                                    'list-group-item': true,
                                    'active': category === pageContext.category,
                                });

                                return <li key={`category-${index}`} className={ButtonClass}>
                                    <Link to={`/${linkTranslation}/${kebabCase(category)}`} role="button">
                                        {category}
                                        <span className="badge badge-primary">{pageContext.countCategories[category]}</span>
                                    </Link>
                                </li>
                            })}
                        </ul>
                    </div>
                </Collapse>
            </div>
        </React.Fragment>
    )
}

export default injectIntl(ComponentStateless)